<div
  class="sidenav"
  [class.mr-12]="!showInfoPanel && !showConfigPanel && !showResourcesPanel && !showTypeformPanel && !showMaterialPanel"
  [ngClass]="{ 'cursor-wait': (teacherFacade.isLoadingCursor$ | async) === true }">
  <div class="sidenav-options" (click)="toggle($event)">
    <button *ngIf="isTeacher && (teachingInfo$ | async)" id="btnInfo" class="dropdown-btn">
      <svg-icon key="{{ showInfoPanel ? 'info-purple' : 'info' }}"></svg-icon>
    </button>
    <button id="btnMaterial" class="dropdown-btn" *ngIf="(materials$ | async)?.suggested">
      <svg-icon key="{{ showMaterialPanel ? 'material-purple' : 'material' }}"></svg-icon>
    </button>
    <button
      *ngIf="isTeacher && (tags$ | async) && activity.typology.name !== activityTypologyName.THEORETICAL_RESOURCE"
      id="btnConfig"
      class="dropdown-btn">
      <svg-icon key="{{ showConfigPanel ? 'config-purple' : 'config' }}"></svg-icon>
    </button>
    <button *ngIf="isTeacher" id="btnTypeform" class="dropdown-btn">
      <svg-icon key="smile"></svg-icon>
    </button>
    <div class="menu__border--bottom menu__border menu__border__inactive"></div>
  </div>

  <div class="svg-container">
    <svg class="svg menu__border__inactive" width="0.711111in" height="1.64444in" viewBox="0 0 64 148">
      <clipPath id="menu" clipPathUnits="objectBoundingBox" transform="scale(0.0099999999999999 0.003999999999999)">
        <path
          fill="none"
          stroke="black"
          stroke-width="1"
          d="M 35.50,4.50 C 35.50,16.00 29.50,38.00 0.00,38.00 0.00,38.00 0.00,110.00 0.00,110.00 29.50,110.00
            35.50,136.00 35.50,147.50 35.50,147.50 394.00,147.50 394.00,147.50 394.00,147.50 394.00,0.00 394.00,0.00
            394.00,0.00 35.50,0.00 35.50,0.00 35.50,0.00 35.50,4.50 35.50,4.50 Z" />
      </clipPath>
    </svg>
  </div>

  <div class="sideContentNav shadow" [@enabledStateChange]="stateOfElement">
    <!-- INFO PANEL -->
    <panel id="infoPanel" *ngIf="showInfoPanel">
      <div id="infoContent" class="dropdown-container">
        <h4 class="content-title font-poppins">
          {{ 'f.side-nav.info.title' | translate }}
          <div class="cross" (click)="crossClose()">
            <svg-icon key="cross-icon"></svg-icon>
          </div>
        </h4>
        <div class="divide-y divide-grisMedio1" *ngIf="!enableTeachingPanel">
          <div class="p-3 flex justify-between items-center panel__element pointer" (click)="selectedTeachingInfo(0)">
            {{ 'f.side-nav.info.description' | translate }}
            <svg-icon size="lg" [color]="'#4F4F4F'" key="arrow-forward"></svg-icon>
          </div>
          <div
            class="p-3 flex justify-between items-center panel__element pointer"
            *ngIf="(teachingInfo$ | async).contents.length > 0"
            (click)="selectedTeachingInfo(1)">
            {{ 'f.side-nav.info.knowledge' | translate }}
            <svg-icon size="lg" [color]="'#4F4F4F'" key="arrow-forward"></svg-icon>
          </div>
          <div
            class="p-3 flex justify-between items-center panel__element pointer"
            *ngIf="(teachingInfo$ | async).competences.length > 0"
            (click)="selectedTeachingInfo(2)">
            {{ 'f.side-nav.info.competences-criterias' | translate }}
            <svg-icon size="lg" [color]="'#4F4F4F'" key="arrow-forward"></svg-icon>
          </div>
          <div
            class="p-3 flex justify-between items-center panel__element pointer"
            *ngIf="(teachingInfo$ | async).relatedSteps.length > 0"
            (click)="selectedTeachingInfo(4)">
            {{ 'f.side-nav.info.steps' | translate }}
            <svg-icon size="lg" [color]="'#4F4F4F'" key="arrow-forward"></svg-icon>
          </div>
        </div>

        <ng-container
          *ngIf="enableTeachingPanel"
          [ngTemplateOutlet]="teachingInfoTemplate"
          [ngTemplateOutletContext]="{ $implicit: (teachingInfo$ | async) }"></ng-container>
      </div>
    </panel>
    <!-- END INFO PANEL -->

    <!-- MATERIAL PANEL -->
    <panel id="MaterialPanel" *ngIf="showMaterialPanel">
      <div id="MaterialContent" class="dropdown-container">
        <div class="cross" *ngIf="isTry" (click)="crossClose()">
          <svg-icon key="cross-icon"></svg-icon>
        </div>
        <zero-info-demo *ngIf="isTry"></zero-info-demo>
        <h4 *ngIf="!isTry" class="content-title font-poppins">
          <span [innerHTML]="((materials$ | async)?.suggested?.title | striphtml) || ('f.side-nav.material.title' | translate)"></span>
          <div class="cross" (click)="crossClose()">
            <svg-icon key="cross-icon"></svg-icon>
          </div>
        </h4>

        <div
          *ngIf="(materials$ | async)?.suggested?.content && !isTry"
          class="sidenav-options__list"
          [innerHTML]="(materials$ | async)?.suggested?.content"></div>

        <ng-container *ngIf="!isTeacher && !(materials$ | async).suggested && !isTry">
          <span>{{ 'f.side-nav.resource.no-materials' | translate }}</span>
        </ng-container>
      </div>
    </panel>
    <!-- END MATERIAL PANEL -->

    <!-- CONFIG PANEL -->
    <panel id="ConfigPanel" *ngIf="showConfigPanel && isTeacher && (tags$ | async)">
      <div id="ConfigContent" class="dropdown-container">
        <h4 class="content-title font-poppins">
          {{ 'f.side-nav.feature.title' | translate }}
          <div class="cross" (click)="crossClose()">
            <svg-icon key="cross-icon"></svg-icon>
          </div>
        </h4>
        <div class="divide-y divide-grisMedio1" *ngIf="!isVisible">
          <div *ngFor="let feature of features; index as i">
            <div
              class="p-3 flex justify-between"
              *ngIf="
                (feature.name === featureName.IS_SOLUTIONARY && isSolutionaryAvailable) || feature.name !== featureName.IS_SOLUTIONARY
              ">
              {{ feature.title | translate }}
              <div class="flex justify-between items-center w-16">
                <svg-icon class="tooltip cursor-pointer" fontSize="large" key="help"></svg-icon>
                <tekman-tooltip [text]="feature.help | translate"></tekman-tooltip>
                <mat-slide-toggle
                  color="primary"
                  [checked]="feature.active"
                  [disabled]="feature.disable"
                  (change)="customizeFeature(feature, $event.checked)"></mat-slide-toggle>
              </div>
            </div>

            <div
              *ngIf="feature.customizedStudents !== undefined && feature.active"
              class="flex flex-wrap items-center -mx-4 overflow-hidden mb-4">
              <div class="pl-8 overflow-hidden">
                <svg-icon key="custom-activity" class="custom-feature"></svg-icon>
              </div>
              <div class="px-2 overflow-hidden">{{ 'f.side-nav.customize' | translate }}</div>
              <div class="overflow-hidden text-grisMedio2" [ngClass]="amountCustomizeStudents(feature) ? 'pl-24' : 'pl-16'">
                <span *ngIf="amountCustomizeStudents(feature)">{{ 'f.side-nav.everybody' | translate }}</span>
                <span *ngIf="!amountCustomizeStudents(feature)">{{
                  'f.side-nav.students' | translate: { value: feature?.amountCustom }
                }}</span>
              </div>
              <div class="px-4 overflow-hidden cursor-pointer">
                <svg-icon
                  class="tooltip"
                  fontSize="small"
                  [color]="'#4F4F4F'"
                  key="arrow-forward"
                  (click)="setVisibleFeature(feature, true)"></svg-icon>
                <tekman-tooltip *ngIf="feature.customize.length === 0" text="{{ 'f.side-nav.noStudents' }}"></tekman-tooltip>
              </div>
            </div>
          </div>
        </div>

        <ng-container
          *ngIf="enabledFeature?.visible"
          [ngTemplateOutlet]="studentList"
          [ngTemplateOutletContext]="{ $implicit: enabledFeature }"></ng-container>
      </div>
    </panel>
    <!-- END CONFIG PANEL -->

    <!-- TYPEFORM PANEL -->
    <panel id="TypeformPanel" *ngIf="showTypeformPanel && isTeacher">
      <div id="TypeformContent" class="dropdown-container">
        <h4 class="content-title font-poppins">
          {{ 'f.side-nav.typeform.title' | translate }}
          <div class="cross" (click)="crossClose()">
            <svg-icon key="cross-icon"></svg-icon>
          </div>
        </h4>
        <tekman-typeform [activity]="activity"></tekman-typeform>
      </div>
    </panel>

    <!-- END TYPEFORM PANEL -->
  </div>
</div>

<ng-template #studentList let-feature>
  <div class="divide-y divide-grisMedio1">
    <div class="py-3 flex items-center">
      <div class="pr-4 overflow-hidden cursor-pointer">
        <svg-icon fontSize="small" [color]="'#4F4F4F'" key="arrow-back" (click)="setVisibleFeature(feature, false)"></svg-icon>
      </div>
      {{ 'f.side-nav.customize.title' | translate: { value: feature.title | translate | lowercase } }}
    </div>
    <div>
      <tekman-checkbox-tree
        [dataCheckboxTree]="feature.customize"
        [avoidRefresh]="avoidRefresh"
        (checklistSelected)="checklistSelected(feature, $event)"></tekman-checkbox-tree>
    </div>
  </div>
</ng-template>

<!-- RESOURCES PANEL OPTIONS -->
<ng-template #resourcesTemplate let-resources>
  <container-element [ngSwitch]="resource">
    <div *ngSwitchCase="0">
      <div class="divide-y divide-grisMedio1">
        <div class="p-3 panel__element pointer" (click)="selectedResource(0)">
          <svg-icon size="lg" [color]="'#4F4F4F'" key="arrow-back"></svg-icon>
          <span class="pl-4">{{ 'f.side-nav.resource.video' | translate }}</span>
        </div>
        <div
          *ngFor="let videoResource of resources?.video"
          class="p-3 resources__video cursor-pointer"
          (click)="showVideo(videoResource.url, videoResource.title)">
          <span class="font-medium">{{ videoResource.title | translate }}</span>
          <svg-icon key="play" class="aria-hidden ml-2" size="xs"></svg-icon>
        </div>
      </div>
    </div>
    <div *ngSwitchCase="1">
      <div class="divide-y divide-grisMedio1">
        <div class="p-3 panel__element pointer" (click)="selectedResource(1)">
          <svg-icon size="lg" [color]="'#4F4F4F'" key="arrow-back"></svg-icon>
          <span class="pl-4">{{ 'f.side-nav.resource.theoric' | translate }}</span>
        </div>
        <div *ngFor="let theoricResource of resources?.resources; let i = index" class="p-3">
          <ul
            *ngFor="let exercise of theoricResource.exercises"
            class="resources__theoric"
            [ngClass]="exercise.exerciseId ? 'resources__theoric--hover' : ''">
            <li
              [routerLink]="exercise.exerciseId ? '/' + appRoutes.activities + '/' + theoricResource.activityId : null"
              [fragment]="exercise.exerciseId">
              <p class="font-medium" [innerHTML]="exercise.title"></p>
              <div *ngIf="exercise.subsections !== null">
                <ul *ngFor="let subsection of exercise.subsections">
                  <li [innerHTML]="subsection.title"></li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div *ngSwitchCase="2">
      <div>
        <div class="p-3 panel__element pointer divide-bottom" (click)="selectedResource(2)">
          <svg-icon size="lg" [color]="'#4F4F4F'" key="arrow-back"></svg-icon>
          <span class="pl-4">{{ 'f.side-nav.resource.selfEvaluation' | translate }}</span>
        </div>

        <div
          class="self-assessment-attachments grid grid-cols-10 grid-rows-1 items-center p-3"
          *ngFor="let selfAssessmentResource of selfAssessmentResources$ | async; let i = index">
          <p class="bodySMedium col-span-7">
            {{ selfAssessmentResource.fileName }}
          </p>
          <div class="self-center col-start-10 justify-self-center">
            <a href="{{ selfAssessmentResource.url }}" download target="_blank">
              <svg-icon class="cursor-pointer justify-self-end col-start-10" key="icon-download" size="xl"></svg-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div *ngSwitchCase="3">
      <div class="divide-y divide-grisMedio1">
        <div class="p-3 panel__element pointer" (click)="selectedResource(3)">
          <svg-icon size="lg" [color]="'#4F4F4F'" key="arrow-back"></svg-icon>
          <span class="pl-4">{{ 'f.side-nav.resource.platform' | translate }}</span>
        </div>
        <div
          *ngFor="let platform of platformResources; let i = index"
          class="p-3 pointer resources__platform"
          (click)="openLink(platform.link)">
          <svg-icon key="{{ platform.image }}"></svg-icon>
          <p class="font-medium">{{ platform.title | translate }}</p>
        </div>
      </div>
    </div>
  </container-element>
</ng-template>
<!-- END RESOURCES PANEL OPTIONS -->

<div *ngIf="resizing" class="resizing-bg"></div>
<div *ngIf="showVideoModal" class="draggable-container container" cdkDragBoundary=".activities__wrapper" cdkDrag>
  <div class="bg-gray">
    <div class="flex justify-between items-center">
      <div class="flex items-center pointer w-full" cdkDragHandle>
        <svg-icon key="drag" size="xxl" class="items-center"></svg-icon>
        <div class="overline mx-6 h2-spacing">{{ videoResourceTitle }}</div>
      </div>
      <div class="flex pointer">
        <svg-icon key="cross-icon" size="l" class="items-center" (click)="hideVideo()"></svg-icon>
      </div>
    </div>
  </div>
  <div class="content">
    <div *ngIf="resizing" class="resizing-bg"></div>
    <iframe title="{{ videoResourceTitle }}" [attr.src]="videoResourceURL" allow="fullscreen; picture-in-picture"></iframe>
  </div>
</div>

<ng-template #teachingInfoTemplate let-teaching>
  <container-element [ngSwitch]="teachingInfo">
    <some-element *ngSwitchCase="0">
      <div class="divide-y divide-grisMedio1">
        <div class="p-3 panel__element pointer flex items-center" (click)="showTeachingPanel()">
          <svg-icon size="lg" [color]="'#4F4F4F'" key="arrow-back"></svg-icon>
          <span class="pl-4">{{ 'f.side-nav.info.description' | translate }}</span>
        </div>
        <div class="pt-3 pl-3">
          {{ teaching.description }}
        </div>
      </div>
    </some-element>
    <some-element *ngSwitchCase="1">
      <div class="divide-y divide-grisMedio1">
        <div class="p-3 panel__element pointer flex items-center" (click)="showTeachingPanel()">
          <svg-icon size="lg" [color]="'#4F4F4F'" key="arrow-back"></svg-icon>
          <span class="pl-4"> {{ 'f.side-nav.info.knowledge' | translate }}</span>
        </div>
        <div class="pt-3 pl-3">
          <ul class="list-disc pl-8">
            <li class="leading-8" *ngFor="let content of teaching.contents">{{ content }}</li>
          </ul>
        </div>
      </div>
    </some-element>
    <some-element *ngSwitchCase="2">
      <div class="divide-y divide-grisMedio1">
        <div class="p-3 panel__element pointer flex items-center" (click)="showTeachingPanel()">
          <svg-icon size="lg" [color]="'#4F4F4F'" key="arrow-back"></svg-icon>
          <span class="pl-4">{{ 'f.side-nav.info.competences-criterias' | translate }}</span>
        </div>
        <div class="pt-3 pl-3">
          <div *ngFor="let competence of teaching.competences" class="pb-4">
            <p class="font-medium leading-6 text-base">{{ competence.title }}</p>
            <ul class="list-disc pl-6">
              <li class="leading-8">{{ competence.dimension }}</li>
              <ul class="list-disc pl-6">
                <li class="leading-8">{{ competence.subCompetence.title }}</li>
              </ul>
            </ul>
          </div>
        </div>
        <div class="pl-3 no-top-border">
          <div *ngFor="let competence of teaching.competences" class="pb-4">
            <ng-container *ngIf="competence.subCompetence.evaluationCriteria">
              <p class="font-medium leading-6 text-base">{{ 'f.submenu.evaluation.criterias' | translate }}</p>
              <ul class="list-disc pl-6">
                <li class="leading-8">{{ competence.subCompetence.evaluationCriteria }}</li>
                <ul class="list-disc pl-6">
                  <li class="leading-8">{{ competence.subCompetence.evaluationItem }}</li>
                </ul>
              </ul>
            </ng-container>
          </div>
        </div>
      </div>
    </some-element>
    <some-element *ngSwitchCase="3">
      <div class="divide-y divide-grisMedio1">
        <div class="p-3 panel__element pointer flex items-center" (click)="showTeachingPanel()">
          <svg-icon size="lg" [color]="'#4F4F4F'" key="arrow-back"></svg-icon>
          <span class="pl-4">{{ 'f.side-nav.info.intelligence' | translate }}</span>
        </div>
        <div class="pt-3 pl-3">
          <ul class="list-disc pl-8" *ngFor="let intelligence of teaching.intelligences">
            <li class="leading-8">{{ intelligence }}</li>
          </ul>
        </div>
      </div>
    </some-element>
    <some-element *ngSwitchCase="4">
      <div class="divide-y divide-grisMedio1">
        <div class="p-3 panel__element pointer flex items-center" (click)="showTeachingPanel()">
          <svg-icon size="lg" [color]="'#4F4F4F'" key="arrow-back"></svg-icon>
          <span class="pl-4">{{ 'f.side-nav.info.steps' | translate }}</span>
        </div>
        <div class="pt-3 pl-3">
          <ul class="list-disc pl-8" *ngFor="let step of teaching.relatedSteps">
            <li class="leading-8">{{ step }}</li>
          </ul>
        </div>
      </div>
    </some-element>
  </container-element>
</ng-template>
